<template>
  <div>
    <p class="text-muted text-uppercase m-0 text-center">Homework Recording</p>
    <p class="h3 text-dark-blue font-weight-bold text-center">Criteria 001</p>

    <hr class="my-4" />

    <p class="h5 text-center">
      Grant
      <span class="text-orange font-weight-bold">2 coins</span>
      to <span class="text-capitalize">{{getChildSelectedName}}</span>
    </p>

    <b-row class="align-items-center m-4" align-h="center">
      <b-col cols="6" sm="3" class="d-flex align-items-center flex-column">
        <i
          @click="Qualify(false)"
          class="rounded-circle material-icons text-light p-1 bg-danger biger-icon"
        >clear</i>
        <small class="font-weight-bolder text-uppercase h5 mt-1 text-danger">Undone</small>
      </b-col>
      <b-col cols="6" sm="3" class="d-flex align-items-center flex-column">
        <i
          @click="Qualify(true)"
          class="rounded-circle material-icons p-1 text-light bg-success biger-icon"
        >done</i>
        <small class="font-weight-bolder text-uppercase h5 mt-1 text-success">Done</small>
      </b-col>
    </b-row>

    <hr class="my-4" />

    <b-row class="justify-content-center">
      <b-col cols="9" class="pb-3">
        <i class="rounded-circle material-icons text-light p-1 bg-success smaller-icon">done</i>
        <span class="font-weight-bold mx-2">1</span>
        <span class>Total criteria ON TASK</span>
      </b-col>
      <b-col cols="9">
        <i class="rounded-circle material-icons text-light p-1 bg-danger smaller-icon">clear</i>
        <span class="font-weight-bold mx-2">4</span>
        <span class>Total criteria OFF TASK</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions,mapGetters } from "vuex";
export default {
  data: function() {
    return {
      item: this.$route.params.item,
      date: this.$route.params.date
    };
	},
	computed:{
		...mapGetters('user',['getChildSelectedId', 'getChildSelectedName'])
	},
  methods: {
    ...mapActions("checklist", ["setParentCheckValues","fethCheckList"]),
    Qualify(value) {
      this.setParentCheckValues({
        id: this.item.id,
        date: this.date,
        value: value
      });
      this.fethCheckList({childId: this.getChildSelectedId}).then(()=>{
				this.$router.replace("allow-checklist");
			})
      
    }
  }
};
</script>
<style >
.biger-icon {
  font-size: 5em !important;
}
.smaller-icon {
  font-size: 0.8em;
}
</style>